var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { ColoredDataElement } from '../_utils/ColoredDataElement.js';
import { Component, Prop, Watch } from '@sick-davinci/ce-decorators';
import { sanitizeJustifyContent } from '../_utils/JustifyContent.js';
import { defaultShorthandLabels } from '../_utils/NumberFormatter.js';
import { CategoryAxisBuilder } from '../_utils/CategoryAxisBuilder.js';
import { ValueAxisBuilder } from '../_utils/ValueAxisBuilder.js';
import { CssTools } from '../_utils/CssTools.js';
/**
 * contains shared properties and methods for Charts
 */

export let AbstractChart = (_dec = Component({
  tag: 'davinci-abstract-chart',
  abstract: true
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Watch('valueRange'), _dec5 = Reflect.metadata("design:paramtypes", []), _dec6 = Prop({
  reflectAsAttribute: false
}), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Watch('valueAxisMaxTickCount'), _dec9 = Reflect.metadata("design:paramtypes", []), _dec10 = Prop({
  reflectAsAttribute: false
}), _dec11 = Reflect.metadata("design:type", Number), _dec12 = Watch('decimalPlaces'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec14 = Prop({
  reflectAsAttribute: false
}), _dec15 = Reflect.metadata("design:type", String), _dec16 = Watch('valueAxisTitle'), _dec17 = Reflect.metadata("design:paramtypes", []), _dec18 = Prop({
  reflectAsAttribute: false
}), _dec19 = Reflect.metadata("design:type", String), _dec20 = Watch('categoryAxisTitle'), _dec21 = Reflect.metadata("design:paramtypes", []), _dec22 = Prop({
  reflectAsAttribute: false,
  type: String
}), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Prop({
  reflectAsAttribute: false
}), _dec25 = Reflect.metadata("design:type", Number), _dec26 = Watch('axisWidth'), _dec27 = Reflect.metadata("design:paramtypes", []), _dec28 = Prop(), _dec29 = Reflect.metadata("design:type", Boolean), _dec30 = Watch('shorthandLabels'), _dec31 = Reflect.metadata("design:paramtypes", []), _dec32 = Prop({
  reflectAsAttribute: false
}), _dec33 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class AbstractChart extends ColoredDataElement {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_categoryLabels", []);

    _defineProperty(this, "_categoryIcons", []);

    _defineProperty(this, "_justifyCategoryAxis", 'SpaceGreedily');

    _initializerDefineProperty(this, "valueRange", _descriptor, this);

    _initializerDefineProperty(this, "valueAxisMaxTickCount", _descriptor2, this);

    _initializerDefineProperty(this, "decimalPlaces", _descriptor3, this);

    _initializerDefineProperty(this, "valueAxisTitle", _descriptor4, this);

    _initializerDefineProperty(this, "categoryAxisTitle", _descriptor5, this);

    _initializerDefineProperty(this, "axisWidth", _descriptor6, this);

    _initializerDefineProperty(this, "shorthandLabels", _descriptor7, this);

    _initializerDefineProperty(this, "legendLabels", _descriptor8, this);

    _defineProperty(this, "_themeListener", () => {
      this._update();
    });
  }

  /**
   * Sets the labels to be used for the categories.
   *
   * @param labels - the labels to be used for the categories
   */
  _setCategoryLabels(labels) {
    this._categoryLabels = labels;

    this._update();
  }
  /**
   * Gets the labels to be used for the categories.
   *
   * @returns the labels to be used for the categories
   */


  _getCategoryLabels() {
    return this._categoryLabels;
  }
  /**
   * Sets the icons to be used for the categories.
   *
   * @param icons - the icons to be used for the categories
   */


  _setCategoryIcons(icons) {
    this._categoryIcons = icons;

    this._update();
  }
  /**
   * Gets the icons to be used for the categories.
   *
   * @returns the icons to be used for the categories
   */


  _getCategoryIcons() {
    return this._categoryIcons;
  }
  /**
   * The range (minimum and maximum value) that is used to scale the values.
   * This range may be set by the user.
   * Undefined values will be automatically computed from the bar values.
   * An undefined scale will be treated as a linear scale.
   *
   * Please note that the minimum value must be less than the maximum value.
   * Also, the minimum value and the maximum value must be greater than 0 if
   * the value range has a logarithmic scale.
   *
   * Not every type of bar chart supports a logarithmic range. Please refer to
   * the documentation of the bar chart itself to determine if a logarithmic range
   * is supported.
   *
   * @default undefined
   */


  valueRangeWatcher() {
    this._update();
  }
  /**
   * The maximum number of ticks to be used for the value axis.
   *
   * The number of visible ticks depends on
   * - the currently visible value range,
   * - the height of the value axis and
   * - the font used for the tick values (tick values should not overlap).
   *
   * So it might be that there are less ticks visible than the number specified by this property, but there are never more ticks visible.
   *
   * Set this property to a large value (e. g. 100) to ensure that as many ticks as possible are visible.
   *
   * @default 5
   */


  valueAxisMaxTickCountWatcher() {
    this._update();
  }
  /**
   * The number of decimal places to use. Possible values are from 0 to 10.
   *
   * If undefined no fixed number of decimal places will be used.
   *
   * @default undefined
   */


  decimalPlacesWatcher() {
    this._update();
  }
  /**
   * The title of the value axis.
   *
   * Blank strings will be treated as if no title is set.
   *
   * @default empty string
   */


  valueAxisTitleWatcher() {
    this._update();
  }
  /**
   * The title of the category axis.
   *
   * Blank strings will be treated as if no title is set.
   *
   * @default empty string
   */


  categoryAxisTitleWatcher() {
    this._update();
  }
  /**
   * Defines how labels and icons of the category axis are layouted.
   *
   * @default SpaceGreedily
   */


  get justifyCategoryAxis() {
    return this._justifyCategoryAxis;
  }

  set justifyCategoryAxis(value) {
    this._justifyCategoryAxis = sanitizeJustifyContent(value, 'SpaceGreedily');

    this._update();
  }
  /**
   * The width of the axis (in rem) on the left-hand side of the chart.
   *
   * This could be the width of the value-axis (for a vertical chart)
   * or the width of the category-axis (for a horizontal chart).
   *
   * Set to undefined to use the default value for each axis-type.
   *
   * @default undefined.
   */


  axisWidthWatcher() {
    this._update();
  }
  /**
   * use abbreviations for big numbers for value-labels (e.g. k=kilo=1000, m=milli=1/1000, etc.)
   *
   * @default defaultShorthandLabels
   */


  shorthandLabelsWatcher() {
    this._update();
  }
  /**
   * List of all legend-labels. if not set, no legend is displayed.
   */


  _getHostFontFamily() {
    var _this$shadowRoot;

    const host = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.host;

    if (!host) {
      return undefined;
    }

    return CssTools.GET_COMPUTED_FONT_FAMILY(host);
  }

  _computeCategoryAxisStyle(horizontal, hostFontFamily) {
    const categoryAxisBuilder = new CategoryAxisBuilder();
    categoryAxisBuilder.fontFamily = hostFontFamily;
    categoryAxisBuilder.title = this.categoryAxisTitle;
    categoryAxisBuilder.horizontal = !horizontal;
    categoryAxisBuilder.justifyTickContent = this.justifyCategoryAxis;
    categoryAxisBuilder.axisWidth = this.axisWidth;
    categoryAxisBuilder.icons = this._getCategoryIcons();
    categoryAxisBuilder.labels = this._getCategoryLabels();
    const style = categoryAxisBuilder.build();
    style.axisLineWidth = 0.0;
    return style;
  }

  _computeValueAxisStyle(horizontal, hostFontFamily, presentationType = 'Default') {
    const valueAxisBuilder = new ValueAxisBuilder();
    valueAxisBuilder.fontFamily = hostFontFamily;
    valueAxisBuilder.title = this.valueAxisTitle;
    valueAxisBuilder.horizontal = horizontal;
    valueAxisBuilder.maxTickCount = this.valueAxisMaxTickCount;
    valueAxisBuilder.axisWidth = this.axisWidth;
    valueAxisBuilder.shorthandLabels = this.shorthandLabels;
    valueAxisBuilder.decimalPlaces = this.decimalPlaces;
    valueAxisBuilder.presentationType = presentationType;
    return valueAxisBuilder.build();
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "valueRange", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "valueRangeWatcher", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "valueRangeWatcher"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "valueAxisMaxTickCount", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "valueAxisMaxTickCountWatcher", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "valueAxisMaxTickCountWatcher"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "decimalPlaces", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "decimalPlacesWatcher", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "decimalPlacesWatcher"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "valueAxisTitle", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "valueAxisTitleWatcher", [_dec16, _dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "valueAxisTitleWatcher"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "categoryAxisTitle", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "categoryAxisTitleWatcher", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "categoryAxisTitleWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "justifyCategoryAxis", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "justifyCategoryAxis"), _class2.prototype), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "axisWidth", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "axisWidthWatcher", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "axisWidthWatcher"), _class2.prototype), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "shorthandLabels", [_dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return defaultShorthandLabels;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "shorthandLabelsWatcher", [_dec30, _dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "shorthandLabelsWatcher"), _class2.prototype), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec32, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class2)) || _class);
